import classNames from 'classnames';
import React from 'react';
import "./Skills.css";

const skillsData = {
    "ReactJs": 95,
    "TypeScript":90,
    // "NextJs": 85,
    "NodeJs": 80,
    "NextJS": 85,
    "React Native": 80,
    // "Flutter": 75,
};

export default function Skills({ status }) {
    return (
        <div
            className={classNames('skillsContainer', `skillsContainer--${status}`)}
        >
            {Object.keys(skillsData).map((key, index) =>
                <div className="skill" key={index}>
                    <div className="details">
                        <span>{key}</span>
                        <span>{`${skillsData[key]}%`}</span>
                    </div>
                    <div className="bar">
                        <div
                            className={classNames(`innerBar`, `${key.replace(/\s/g, "")}Bar--${status}`)}>
                        </div>
                    </div>
                </div>

            )}
        </div>
    );
}
